module.exports = __webpack_public_path__ + "f2d6e7ede864310f54f3a6a882a412c4.svg";